// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5825f13e","720":"7e4cf19d","732":"3061f1ce","908":"1a39b56a","977":"fb96e744"}[chunkId] + ".chunk.js";
};